import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { UploadDocField } from '../uploadFile';

interface IProps {
  placeholder: string;
  style?: any;
  remark?: any;
  inputValue?: string;
  type?: string;
  defaultValue?: string;
  value?: string;
  onChange?: (val: string) => void;
}

const Upload = (props: IProps) => {
  const [documents, setDocuments] = useState<any>([]);
  const getFileInfo = (value: any) => {
    if (value.length > 0) {
      documents[0] = {
        fileName: value[0].fileName,
        filePath: value[0].filePath,
        url: value[0].url,
      };
    }
    props.onChange && props.onChange(documents[0]);
  };
  useEffect(() => {
    if (props?.value) {
      setDocuments([props?.value]);
    }
  }, [props?.value]);
  return (
    <>
      <Wrapper>
        {props?.value && (
          <span className="title" style={{ marginTop: '5px' }}>
            {props.placeholder}
          </span>
        )}
        <UploadDocField
          value={documents}
          onChange={getFileInfo}
          limit={1}
          accept=".pdf,.doc,.docx,.txt,.rtf, .png, .jpeg, .jpg"
        />
        {<p style={{ position: 'absolute' }}>{props.remark}</p>}
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  height: 150px;
  position: relative;
  .title {
    position: absolute;
    left: 11px;
    top: 11px;
    color: #b7bacb;
    font-size: 14px !important;
  }
  p {
    margin-bottom: 0;
    margin-left: 11px;
    color: #b7bacb !important;
  }
`;

export default Upload;
